<template>
  <div>
    <Modal v-model="userForm" title="新增用户" width="600" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="110">
        <Row>
            <Col span="24">
                <FormItem label="账号" prop="userId" :class="{requireStar:true}" >
                  <Input v-model="formValidate.userId" :maxlength="12" ></Input>
                </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="密码" prop="userPassword" :class="{requireStar:true}">
                    <Input v-model="formValidate.userPassword" type="password"  :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="确认密码" prop="userPassword2" :class="{requireStar:true}">
                    <Input v-model="formValidate.userPassword2"  type="password" :maxlength="16"></Input>
                  </FormItem>
            </Col>
        </Row>
         <Row>
            <Col span="24">
              <FormItem label="选择区域" prop="regionCode">
                <RadioGroup v-model="formValidate.regionCode">
                  <span  @click="selRegion(2)"><Radio label="2">市</Radio></span>
                  <span  @click="selRegion(3)"><Radio label="3">区/县</Radio></span>
                </RadioGroup>
             </FormItem>
            </Col>
        </Row>
        <Row v-show="showDist">
            <Col span="24">
                  <FormItem label="所属区县">
                     <Select ref="selectDist" v-model="formValidate.dist" :clearable="true" style="width:200px">
                        <Option v-for="item in distList" :value="item.groupid" :key="item.groupid">
                          {{ item.groupname }}</Option>
                    </Select>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户类型" prop="userType">
                    <RadioGroup v-model="formValidate.userType">
                      <Radio label="4">管理员</Radio>
                      <Radio label="2">操作者</Radio>
                    </RadioGroup>
                  </FormItem>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                  <FormItem label="用户描述" prop="userDescription">
                    <Input v-model="formValidate.userDescription" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="Enter something..."></Input>
                  </FormItem>
            </Col>
        </Row>
      </Form>
      <!--自定义按钮，解决自带按钮，点击就关闭的问题-->
      <div slot="footer">
        <Button type="text" size="large" @click="cancle">取消</Button>
        <Button type="primary" size="large" @click="handleSubmit('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    components:{
    },
    data() {
         //自定义密码验证规则
          const validateUserId = (rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入账号'));
              } else{
                let re = /^[a-zA-Z].{2,15}$/
                if (!re.test(value)) {
                   callback(new Error('账号必须以字母开头，3-16列'));
                }else{
                     //此处防止初始化用户列表页面后，第一次点击新增按钮打不开模态窗口的问题
                    if (this.userForm == true ) {
                        let url = `/province/sys/user/getUserByUserId`
                        this.req({
                          url: url,
                          method: 'post',
                          data:{
                            userId: value
                          }
                        }).then(response => {
                            let list = response.data.list
                            if (list.length >=1 ) {
                              callback(new Error('账号已经存在'));
                            } else {
                              callback();
                            }
                            
                        }).catch(error => {
                          this.$Message.error('服务器错误:' + error);
                        })
                      }else{
                        callback();
                      }
                }
             
              }
          };
          const validatePass =(rule, value, callback)=> {
              if (value === '') {
                  callback(new Error('请输入密码'));
              } else{
                let reg = /^.{6,16}$/
                if (!reg.test(value)) {
                 return callback(new Error('密码必须6到16位'));
                }else{
                  callback();
                }
              }
          };
          const validatePassCheck = (rule, value, callback)=>{
              if (value === '') {
                  return callback(new Error('请再次输入密码'));
              } else{
                let reg = /^.{6,16}$/
                if (!reg.test(value)) {
                  return callback(new Error('密码必须6到16位'));
                } else if(value !== this.formValidate.userPassword){
                  return callback(new Error('两次密码不一致'));
                }else{
                  callback();
                }
              }
          };
      
      return {
        userForm: false,
        title: '',
        readonly: false,
        show: true,
        showDist: false,
        showBar: false,
        cityList: [],
        distList: [],
        formValidate: {
          id: '',
          city: '',
          dist: '',
          userId: '',
          userPassword: '',
          userPassword2: '',
          userState:'',
          userType:'',
          userDescription:'',
          LastLogonTime:'',
          assetsManage:'',
          regionCode:'2',
        },
        ruleValidate: {
          userId:  [{validator: validateUserId, trigger: 'blur' }],
          userPassword:  [{validator: validatePass, trigger: 'blur' }],
          userPassword2: [{validator: validatePassCheck, trigger: 'blur' }],
          userType: [{
            required: true,
            message: '用户类型不能为空',
            trigger: 'change'
          }],
        },
      }
    },

    methods: {
      openModal(row) {
        
        this.userForm = true
        this.handleReset("formValidate");
        this.formValidate.id = ''
      },
      
      handleSubmit(name) {

        //设置区域编码
        let regCode = null ;
        if (this.formValidate.regionCode == '2') {
          regCode =  this.$store.state.user.regionCode
        }else if (this.formValidate.regionCode == '3') {
          regCode = this.formValidate.dist
        }
        if (regCode == null || regCode == '') {
            this.$Message.error('请选择区域!');
            return
        }
        this.$refs[name].validate((valid) => {
          if (valid) {
            let url = "/province/sys/user/save";
            let myData = {
              id: this.formValidate.id,
              userId: this.formValidate.userId,
              userPassword: this.formValidate.userPassword,
              regionCode: regCode,
              userState: 1,
              userType: this.formValidate.userType,
              userDescription: this.formValidate.userDescription,
              assetsManage: 1,
            }
            this.req({
              url: url,
              method: 'post',
              data: myData
            }).then(response => {
              if (response.status == 200) {
                this.$Message.success('保存成功!');
                this.$parent.loadPage();
              } else {
                this.$Message.error('服务器错误:' + response.status);
              }
              this.userForm = false;
            }).catch(error => {
              this.reponseData = "发生错误，无法显示内容"
            })
          } else {
            return;
          }
        }) 
      },
      handleReset(name) {
         if (this.$refs[name]!==undefined) {
              this.$refs[name].resetFields();
          }
      },
      cancle() {
        this.userForm = false;
      },
       //选择市、区
      selRegion(){
        //获取选中的区域类型
        let id = arguments[0]
          //保存用户的区域类型
        this.formValidate.regionCode = id
        //如果选择区县
        if(id == 3) {
          this.showDist = true
        }else{
          if (this.$refs.selectdist) {
           this.$refs.selectdist.clearSingleSelect()
          }
          this.showDist = false
        }
       
      }
    },
    mounted() {

         //先清空原有数据
          let url = "/province/sys/dcBsgroup/listByParentCode";
          this.req({
            url: url,
            method: 'post',
            data:{
              parentCode: this.$store.state.user.regionCode
            }
          }).then(resp => {
              this.distList = resp.data.list
          }).catch(error => {
              console.log("发生错误："+error)
          })
    },
  }
</script>
<style>
  /*动态必填项className*/
  .requireStar .ivu-form-item-label:before{
    content: '*';
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 12px;
    color: #ed4014;
  }
</style>


// WEBPACK FOOTER //
// src/pages/platform/sys/user/UserFormAddCity.vue